<app-dashboard-box [title]="'common.navigation.alarm-rule.title' | translateSafe"
                   icon="emergency_home"
                   [buttonLabel]="'common.actions.add-alarm-rule' | translateSafe"
                   [buttonIconName]="'add'"
                   (buttonClick)="addAlarmRuleDialogOpen = true">
  <app-table [tableConfig]="tableConfig"
             [tableRows]="tableRows"
             [loading]="loading" />
</app-dashboard-box>

<app-dialog-base
  [class.open]="addAlarmRuleDialogOpen"
  iconLeft="add_diamond"
  [buttonAction]="() => addAlarmRuleDialogOpen = false"
  (outSideClick)="addAlarmRuleDialogOpen = false"
  [title]="'common.actions.add-alarm-rule' | translateSafe">

  @if (alarmRuleSelect.options && alarmRuleSelect.options.length) {
    <app-input-item-selection
      [formData]="alarmRuleSelect"
      (selectedOption)="onAlarmRuleSelect($event)" />
  } @else {
    <p class="empty-alarmRuleList"> {{ 'common.messages.empty.no-rule-available' | translateSafe }} </p>
  }
</app-dialog-base>

@if (editAlarmRule_DeviceId && editAlarmRule_Id) {
  <app-dialog-base
    [class.open]="editAlarmRuleDialogOpen"
    iconLeft="edit"
    [buttonAction]="() => editAlarmRuleDialogOpen = false"
    (outSideClick)="editAlarmRuleDialogOpen = false"
    title="Alarmregel überschreiben">

      <app-device-edit-alarm-rules-edit [mode]="editAlarmRule_Mode"
                                        [deviceId]="editAlarmRule_DeviceId"
                                        [alarmRuleId]="editAlarmRule_Id" />
  </app-dialog-base>
}


